import type { DisputeTypeApiResponse, CreateDisputeTypeRequest, UpdateDisputeTypeRequest } from "@/types/api/dispute-types";
import type { DisputeType } from "@/types/dispute-types";

export function mapDisputeTypeApiToUi(api: DisputeTypeApiResponse): DisputeType {
  return {
    id: String(api.id),
    name: api.name,
    description: api.description ?? "",
    isActive: api.isActive,
    createdAt: api.createdAt,
    updatedAt: api.updatedAt,
    createdBy: api.createdByUserName ?? "",
    workflow: {
      id: "",
      disputeTypeId: String(api.id),
      stages: [],
      transitions: [],
    },
    usageCount: api.usageCount,
    avgResolutionTime: api.avgResolutionTime ?? 0,
    successRate: api.successRate ?? 0,
  };
}

export function mapDisputeTypeUiToCreateRequest(ui: Partial<DisputeType>): CreateDisputeTypeRequest {
  return {
    name: ui.name ?? "",
    description: ui.description || undefined,
    isActive: ui.isActive ?? true,
  };
}

export function mapDisputeTypeUiToUpdateRequest(ui: Partial<DisputeType>): UpdateDisputeTypeRequest {
  return {
    name: ui.name,
    description: ui.description || undefined,
    isActive: ui.isActive,
  };
}
